"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoBannerContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _view = require("../../types/view");
var _headingType = require("../../types/headingType");
var _view2 = require("../../selectors/view/view");
var _HomeownersBanner = require("../../components/HomeownersBanner");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PromoBannerContainer = _ref => {
  let {
    useSelector
  } = _ref;
  const {
    active,
    data
  } = useSelector(_view2.selectView);
  switch (active) {
    case _view.EActiveView.AuthenticationRegistration:
    case _view.EActiveView.PhoneAuth:
      switch (data?.headingType) {
        case _headingType.EHeadingType.NewOfferForm:
          return /*#__PURE__*/React.createElement(_HomeownersBanner.HomeownersBanner, null);
        default:
          return null;
      }
    default:
      return null;
  }
};
exports.PromoBannerContainer = PromoBannerContainer;